import CookieConsent from './_dist/cookie_consent.js'
import ahoy from 'ahoy.js'

function updateAnalytics() {
  if (window.cc.acceptedCategories.indexOf('analytics') == -1) return false

  ahoy.configure({
    visitsUrl: "/poll/visits",
    eventsUrl: "/poll/events",
    cookies: true,
    visitParams: {},
  });

  ahoy.trackView();
  ahoy.trackClicks("a, button, input[type=submit]");
  ahoy.trackSubmits("form");

  const domainGtag = document.getElementsByName("gtag")[0].content

  if (domainGtag) {
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());

    gtag('config', domainGtag);
  }

  const domainGtmId = document.getElementsByName("gtm_id")[0].content
  if (domainGtmId) {
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer',domainGtmId);
  }

  const domainMetaPixel = document.getElementsByName("meta_pixel")[0].content

  if (domainMetaPixel) {
    if (typeof fbq !== "undefined") fbq('init', domainMetaPixel);
    if (typeof fbq !== "undefined") fbq('track','PageView');
  }
}

export default function() {
  if (document.querySelector("[data-tabs]")) new Tabby('[data-tabs]');

  if (!window.testEnvironment){
      window.CookieConsent = null
      CookieConsent()
      window.cc = new window.CookieConsent({
        title: "Wir verwenden Cookies 🍪",
        description: `Wir verwenden Cookies. Viele sind notwendig, um die Website und ihre Funktionen zu betreiben, andere sind für statistische oder Marketingzwecke. Mit der Entscheidung "Ablehnen" werden wir Ihre Privatsphäre respektieren und keine Cookies setzen, die nicht für den Betrieb der Seite notwendig sind.`,
        buttons: {
          acceptAll: "Alle akzeptieren",
          acceptSelected: "akzeptieren",
          reject: "Ablehnen",
          showSettings: "Cookie Einstellungen",
          hideSettings: "Schließen",
        },
        categories: {
          essentials: {
            label: "Essentiell",
            description: `Essenzielle Cookies ermöglichen grundlegende Funktionen und sind für die einwandfreie Funktion der Website erforderlich.`,
            checked: true,
            mandatory: true
          },
          analytics: {
            label: "Statistik",
            description: `Statistik-Cookies helfen Webseiten-Besitzern zu verstehen, wie Besucher mit Webseiten interagieren, indem Informationen anonym gesammelt und gemeldet werden.`,
            checked: true,
            mandatory: true
          }
        },
      })
    window.cc.on("change", (cc) => {
      updateAnalytics()
    })

    updateAnalytics()
  }
}
